const HEADING_SELECTOR = 'h1, h2, h3, h4, h5, h6, .panel-heading, .panel-title, legend';
const MAX_HEADING_LENGTH = 120;

export const elementText = (el) =>
  (el?.innerText ?? el?.textContent ?? '').replace(/\s+/g, ' ').trim();

export const isHidden = (el) => {
  const win = el.ownerDocument?.defaultView;
  if (!win?.getComputedStyle) return false;
  for (let node = el; node && node.nodeType === 1; node = node.parentElement) {
    const style = win.getComputedStyle(node);
    if (style.display === 'none' || style.visibility === 'hidden') return true;
  }
  return false;
};

const headingIn = (el) => {
  if (el.matches?.(HEADING_SELECTOR)) return el;
  const found = el.querySelectorAll?.(HEADING_SELECTOR);
  return found && found.length ? found[found.length - 1] : null;
};

/**
 * Closest heading that precedes `el` in its ancestors' sibling chains — the
 * title SEAL renders above a table or chart.
 */
export const nearestHeading = (el, maxDepth = 6) => {
  let node = el;
  for (let depth = 0; node && depth < maxDepth; depth += 1) {
    for (let sib = node.previousElementSibling; sib; sib = sib.previousElementSibling) {
      if (sib.matches?.('table, canvas, svg')) break;
      const heading = headingIn(sib);
      const text = heading && elementText(heading);
      if (text) return text.slice(0, MAX_HEADING_LENGTH);
    }
    node = node.parentElement;
  }
  return '';
};

export const byDocumentOrder = (a, b) => {
  if (a === b) return 0;
  // eslint-disable-next-line no-bitwise
  return a.compareDocumentPosition(b) & 4 ? -1 : 1;
};
